import R from '../../../../core-res/R';
import SIZE from '../constant/size';
const textStyle = {
    small: {
        fontSize: R.typography.fontSize.small,
        lineHeight: 16,
    },
    medium: {
        fontSize: R.typography.fontSize.medium,
        lineHeight: 24,
    },
    large: {
        fontSize: R.typography.fontSize.large,
        lineHeight: 32,
    },
};
export function getButtonTextStyle(size) {
    switch (size) {
        case SIZE.SMALL:
            return textStyle.small;
        case SIZE.MEDIUM:
            return textStyle.medium;
        case SIZE.LARGE:
            return textStyle.large;
        default:
            throw new Error(`Invalid button size ${size}`);
    }
}
